import { useEffect, useState } from "react";
import { maintenanceFields } from "../../../constants/forms/manutencao/maintenanceFields";
import { useSectionFields } from "../../../hooks/useSectionFields";
export const useMaintenancePageLogic = (whatToSenderSelect) => {
  const [maintenanceSection, itemsSection] = maintenanceFields;
  const [maintenanceFieldsState, setMaintenanceFieldsState] = useState(
    maintenanceSection.fields
  );
  const [itemsFieldsState, setItemsFieldsState] = useState(itemsSection.fields);

  const { updateField: updateProps, removeFields } = useSectionFields();

  useEffect(() => {
    let updatedMaintenanceFields = [...maintenanceSection.fields];
    let updatedItemsFields = [...itemsSection.fields];

    if (
      !whatToSenderSelect.selectedValue?.value ||
      typeof whatToSenderSelect.selectedValue?.value === "undefined"
    ) {
      updatedMaintenanceFields = removeFields({
        arrayDependente: updatedMaintenanceFields,
        field_id: [
          "maintenance.equipment_id",
          "maintenance.product_item_id",
          "maintenance.product_quantity",
        ],
      });
    }

    if (whatToSenderSelect.selectedValue?.value === "equipment") {
      updatedMaintenanceFields = removeFields({
        arrayDependente: updatedMaintenanceFields,
        field_id: [
          "maintenance.product_item_id",
          "maintenance.product_quantity",
        ],
      });
    }

    if (whatToSenderSelect.selectedValue?.value === "product") {
      updatedMaintenanceFields = removeFields({
        arrayDependente: updatedMaintenanceFields,
        field_id: ["maintenance.equipment_id"],
      });

      // Se for produto é necessário remover os campos de cliente e equipamento do items
      updatedItemsFields = removeFields({
        arrayDependente: updatedItemsFields,
        field_id: ["items.returned_customer_id", "items.returned_equipment_id"],
      });

      updatedMaintenanceFields = updateProps({
        arrayDependente: updatedMaintenanceFields,
        field_id: ["maintenance.maintenance_date"],
        updates: {
          fullWidth: true,
        },
      });
    }
    setMaintenanceFieldsState(updatedMaintenanceFields);
    setItemsFieldsState(updatedItemsFields);
  }, [
    itemsSection.fields,
    maintenanceSection.fields,
    removeFields,
    updateProps,
    whatToSenderSelect.selectedValue?.value,
  ]);

  return {
    maintenanceFieldsState,
    itemsFieldsState,
  };
};
